import { render, staticRenderFns } from "./the-honor-card-two.vue?vue&type=template&id=47f14f5c&scoped=true&"
import script from "./the-honor-card-two.vue?vue&type=script&lang=js&"
export * from "./the-honor-card-two.vue?vue&type=script&lang=js&"
import style0 from "./the-honor-card-two.vue?vue&type=style&index=0&id=47f14f5c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47f14f5c",
  null
  
)

export default component.exports